import Box from "ds/components/Box";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";

type Props = {
  selectedLength: number;
  onSelectAll?: () => void;
  onResetAll: () => void;
  allSelected?: boolean;
  /**
   * Matches table bulk selection: when nothing is selected, only **Select all** is shown;
   * when one or more rows are selected, only **Clear all** is shown (no “or” between both).
   * When false (default), partially selected lists show both links like the stack dependencies dropdown.
   */
  exclusiveSelectOrClearLinks?: boolean;
};

const DropdownSelectClearAll = ({
  onSelectAll,
  onResetAll,
  selectedLength = 0,
  allSelected,
  exclusiveSelectOrClearLinks = false,
}: Props) => {
  const showSelectAll =
    Boolean(onSelectAll) &&
    !allSelected &&
    (exclusiveSelectOrClearLinks ? selectedLength === 0 : true);

  const showClearAll = selectedLength > 0;

  return (
    <Box gap="medium">
      <Typography tag="span" variant="p-body3">
        <Typography tag="span" variant="p-t7">
          {selectedLength}
        </Typography>{" "}
        selected
      </Typography>
      {showSelectAll && (
        <Link size="small" onPress={onSelectAll}>
          Select all
        </Link>
      )}
      {!exclusiveSelectOrClearLinks && onSelectAll && !allSelected && selectedLength > 0 && (
        <Typography tag="span" variant="p-body3">
          or
        </Typography>
      )}
      {showClearAll && (
        <Link size="small" onPress={onResetAll}>
          Clear all
        </Link>
      )}
    </Box>
  );
};

DropdownSelectClearAll.displayName = "DS.Dropdown.SelectClearAll";
export default DropdownSelectClearAll;
